import { Moment } from "moment";
import { RequestedCategory } from "types/interfaces/service-request";
import { IUserViewInfo } from "types/interfaces/user-info";

export enum ProvisioningResponseTypeEnum {
  KIOSK_ROOM = "kiosk.room",
}

export enum PlatformEnum {
  WEB = "web",
  ANDROID = "android",
  IOS = "ios",
}

export interface ProvisioningResponse {
  type: ProvisioningResponseTypeEnum.KIOSK_ROOM;
  refreshToken: string;
  roomId?: string;
}

export interface AuthTokenResponse {
  token: string;
}

export interface IMeetingRoomKioskInfo {
  id: string;
  name: string;
  description: string;
  imageUrl?: string;
  capacity: number;
  timezone: string;
  checkIn: { enabled: boolean };
  equipment?: { title: string; id: string }[];
  serviceRequestsEnabled: boolean;
}

export interface IMeetingRoomKioskData {
  meetingRoom: IMeetingRoomKioskInfo;
  events: IMeetingRoomKioskEventData[];
}

export interface IMeetingRoomKioskBookingCreationData {
  subject: string;
  description?: string;
  startTime: string;
  endTime: string;
  isPrivate?: boolean;
}
export interface IMeetingRoomKioskEventData {
  id: string;
  subject?: string;
  startTime: string;
  endTime: string;

  hasServiceRequest?: boolean;
  checkIn: {
    checkedIn: boolean;
    autoCancellationAt: string;
  };

  owner?: IUserViewInfo;

  // Not returned by API but possibly needed for UI
  bookingId?: string;
  type: "occurrence" | "legacy" | "single";
  roomId: string;
  virtualId: string;
  seriesId: string;
}

export interface IMeetingRoomKioskEventDetailsData
  extends IMeetingRoomKioskEventData {
  description?: string;
  serviceRequest?: {
    requestedCategories: RequestedCategory[];
  };
  attendees?: {
    id: string;
    firstName?: string;
    lastName?: string;
    avatarColor?: string;
    profileImage?: string;
    email?: string;
    type: string;
  }[];
}
export enum MeetingRoomKioskStatus {
  CHECK_IN = "check-in",
  FREE = "free",
  OCCUPIED = "occupied",
}

export enum KioskScheduleEntrySize {
  NONE = "NONE",
  MINI = "MINI",
  X_SMALL = "X_SMALL",
  SMALL = "SMALL",
  MEDIUM = "MEDIUM",
  LARGE = "LARGE",
}

export interface IKioskScheduleEntry {
  id: string;
  status: MeetingRoomKioskStatus;
  startMoment: Moment;
  startTime: string;
  endTime: string;
  title: string;
  event?: IMeetingRoomKioskEventData;
  organiser?: IMeetingRoomKioskEventData["owner"];
  hasCatering?: boolean;
  size: KioskScheduleEntrySize;
  isPast?: boolean;
  duration: number;
}
